export function msgbox(ctx) {
    return {
        styles: {
            // LV_MSGBOX_PART_BG
            main: { ...ctx.pretty, text_font: 32 },
            // LV_MSGBOX_PART_BTN_BG — same bg as body, no separator
            items: { bg_color: ctx.pretty.bg_color, bg_opa: 255, border_width: 0 },
            // LV_MSGBOX_PART_BTN — pill-shaped buttons
            item_buttons: {
                bg_color:     ctx.pretty.bg_color,
                bg_opa:       255,
                border_color: ctx.btnBorder,
                border_width: 2,
                radius:       999,
                text_color:   ctx.TEXT_DEFAULT,
                text_font:    32,
            },
        },
    };
}
